import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import {
  RECOMMENDATION_TYPES,
  CONTEXTUAL_ENTITY_TYPE,
} from '@bingads-webui-campaign/recommendation-core';
import { withContextualAttributeTemplate } from '@bingads-webui-campaign/recommendation-contextual-attribute';

import template from './keyword-column.pug';

export class KeywordColumn extends ProjectionGridBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'keyword',
      property: 'KeywordColumn',
      title: i18n.getString('Details_View_Keyword'),
      bodyClasses: ['grid-column-keyword', 'actionable'],
      colClasses: ['col-longText'],
      type: 'string',
    });

    this.i18n = i18n;
  }

  template({
    value: {
      Opportunities,
      Target: { Keyword, KeywordId },
    },
  }) {
    const recommendationType = Opportunities[0].OpportunityType;
    const noContextualAttribute = ((
      recommendationType === RECOMMENDATION_TYPES.BROAD_MATCH_KEYWORD)
      && Opportunities[0].AlgoID === 0);

    // For bid related recommendations, it needs to format keyword.
    const keywordStr = Keyword;

    return template({
      keyword: noContextualAttribute ? Keyword : withContextualAttributeTemplate({
        opportunityId: Opportunities[0].OpportunityId,
        entityName: keywordStr,
        entityId: KeywordId === null ? Opportunities[0].ReferenceKeywordId : KeywordId,
        entityType: CONTEXTUAL_ENTITY_TYPE.KEYWORD,
        status: 'false',
      }),
    });
  }

  get property() {
    return {
      get: _.identity,
      property: 'KeywordColumn',
    };
  }
}
